<div class="table-footer">
    <div class="row">
        {#if !!$netto_prices}
            <div class="col-12 text-right">
                { $_("unseated.net") } {#if fullPrice !== null}<span >{$_("webshop.price", [new PriceValue(netto_func(fullPrice)/100)], ["price"])}</span>{:else}<i class="fa fa-spin fa-spinner" />{/if}
            </div>
            <div class="col-12 text-right">
                { $_("unseated.vat") } {#if fullPrice !== null}<span >{$_("webshop.price", [new PriceValue(vat_func(fullPrice)/100)], ["price"])}</span>{:else}<i class="fa fa-spin fa-spinner" />{/if}
            </div>
        {/if}
        <div class="col-12 text-right">
            { $_("unseated.sum") } {#if fullPrice !== null}<span class="primary-text">{$_("webshop.price", [new PriceValue(fullPrice/100)], ["price"])}</span>{:else}<i class="fa fa-spin fa-spinner" />{/if}
        </div>
        {#if !$netto_prices}
            <div class="col-12 text-right">
                { $_("all-prices-with-vat") }
            </div>
        {/if}
    </div>
</div>


<script lang="ts">
    import { derived, readable } from "svelte/store";
    import { catMap } from "./unseated";
    import { depromise } from "@/utils/svelte/proxies";
    import { EventPriceInformation, Shop } from "@ticketmachine/sdk";
    import { _, PriceValue } from "@frontend/translations";
    import { custom_setting } from "@/frontend/base/state";

    const event_ids = derived(catMap, (c) => Array.from(new Set(Object.keys(c).map(k => k.split("-")[0]).map((n) => Number(n)))));
    const events = depromise(null, derived(event_ids, (eids) => Promise.all(eids.map(e => Shop.current.getEventPrices(e)))));

    function calculateFullPrice(events: EventPriceInformation[]|null, cats: Record<string, number>): number|null {
        if (events == null) return null;
        let price = 0;
        for (let [k, v] of Object.entries(cats)) {
            const items = k.split("-").map(n => Number(n));
            const ev = events.find((e) => e.id === items[0]);
            if (ev === null || ev === undefined) return null;

            const cat = ev.categories.find((c) => c.id === items[1]);
            if (cat === null || cat === undefined) return null;
            if (items.length == 2) {
                price += cat.price * v;
                continue;
            }

            const disc = cat.discounts.find((d) => d.id === items[2]);
            if (disc === null || disc === undefined) return null;
            price += disc.price * v;
        }
        return price;
    }

    $: netto_prices = depromise(false, readable(custom_setting<boolean>("netto_prices")))

    $: netto_func = !!$netto_prices ? ((n: number) => n / 1.19) : ((n: any) => n);
    $: vat_func = !!$netto_prices ? ((n: number) => n - (n / 1.19)) : ((n: any) => null);

    $: fullPrice = calculateFullPrice($events, $catMap);
</script>
